import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../services/supplier_appCommonService";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/CustomerConstants";
import {
  addcustomerID,
  // getCustomerList,
  workflow,
} from "../../../redux/feature/customer_app/customerSlice";
import ShowStatus from "../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { SearchField } from "../../../Components/formElements/SearchField";
import SuccessModal from "../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../Components/Modal/supplier_app/BroadcastModel";
import SupplierDeactivateModel from "../../../Components/Modal/supplier_app/SupplierDeactivateModel";
import CreateCustomerMasterModal from "../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import PLMConstants from "../../../common/PLMConstants";
import {
  articleNr,
  getArticleList,
} from "../../../redux/feature/plm_app/plmSlice";
import UploadArticleModal from "../ProductMatrix/Article_Master_Bulk_Upload/UploadArticleModal";
import ArticleEditModal from "./ArticleEditModal";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";

const ArticleList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Article");
  localStorage.setItem("submenu", "Article List");

  let articleData = useSelector((state) => state?.plm?.article); // User Details from Store
  let articleTable = useSelector((state) => state?.plm?.article?.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const [getDropdownData, setDropdownData] = useState("");

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [modalShowEditProduct, setModalShowEditProduct] = useState(false);
  const [productMatrixdat, setProductMatrixdat] = useState();

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const Brand = [
    { id: 1, name: "USPA" },
    { id: 2, name: "Arrow" },
    { id: 2, name: "Flying Machine" },
  ];
  const Category = [
    { id: 1, name: "C1" },
    { id: 2, name: "C2" },
    { id: 2, name: "C3" },
  ];
  const Divison = [
    { id: 1, name: "Divison 1" },
    { id: 2, name: "Divison 2" },
    { id: 2, name: "Divison 3" },
  ];
  const Season = [
    { id: 1, name: "Season 1" },
    { id: 2, name: "Season 2" },
    { id: 2, name: "Season 3" },
  ];

  useEffect(() => {
    if (!getDropdownData) return;

    const updatedFields = {
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    };

    if (getDropdownData?.textField === "brand") {
      updatedFields.brand = getDropdownData?.name;
      updatedFields.brand = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "category") {
      updatedFields.category = getDropdownData?.name;
      updatedFields.category = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "division") {
      updatedFields.division = getDropdownData?.name;
      updatedFields.division = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "season") {
      updatedFields.season = getDropdownData?.name;
      updatedFields.season = getDropdownData?.name;
    }

  }, [getDropdownData]);

  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      // console.log("obj", obj);
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      // console.log("obj", obj);
      await ItemService.supplierDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = (articleNumber) => {
    dispatch(articleNr(articleNumber));
    navigate(PLMConstants.PRODUCT_ARTICLES_ARTICLE_DETAILS);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(articleData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "GET_ARTICLE_LIST",
      module: "ARTICLE",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getArticleList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "GET_ARTICLE_LIST",
      module: "ARTICLE",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getArticleList(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_ARTICLE_LIST",
      module: "ARTICLE",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getArticleList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();
    loadInitialSuuplierData(); // fetch page 1 of users
    dispatch(workflow({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleData?.data]);
  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "GET_ARTICLE_LIST",
      module: "ARTICLE",
      page: 1,
      per_page: 10,
    };
    dispatch(getArticleList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    {
      name: "Article",
      selector: (row) => row?.articleNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.articleNr)}>
          {row.articleNr || "-"}{" "}
        </button>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Edit",
      selector: (row) => row?.articleNr,
      cell: (row) => (
        <button class="btn btnInfo" onClick={() => showEditProduct(row)}>
          <i class="bi bi-pencil-square pe-2"></i>
          <sapn class="m-0 p-0 pt-1 text-sm">Edit </sapn>
        </button>
      ),
      sortable: true,
      width: "140px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
        {
          name: "Workflow log",
          selector: (row) => row.workflowActionLogs,
          cell: (row) => (
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-center iconTable"
            >
              <img
                src="assets/img/newIcons/workflow.png"
                alt="attachments"
                style={{ width: "35px" }}
                className="mt-1"
                onClick={() => showStatusInfo(row.workflowActionLogs)}
              />
            </div>
          ),
          sortable: true,
          width: "132px",
        },
      ]
      : []),
    {
      name: "Article Description",
      selector: (row) => row?.articleDescription,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleDescription}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Division",
      selector: (row) => row?.division,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.division}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Article Type",
      selector: (row) => row?.articleType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Article Category",
      selector: (row) => row?.articleCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.articleCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Merchandise Category",
      selector: (row) => row?.merchandiseCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.merchandiseCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Characteristic Profile",
      selector: (row) => row?.characteristicProfile,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.characteristicProfile}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Base Unit Of Measure",
      selector: (row) => row?.baseUnitofMeasure,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.baseUnitofMeasure}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160",
    },
    {
      name: "Net Weight",
      selector: (row) => row?.netWeight,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.netWeight}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Gross Weight",
      selector: (row) => row?.grossWeight,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.grossWeight}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weight Unit",
      selector: (row) => row?.weightUnit,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.weightUnit}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Commodity Code",
      selector: (row) => row?.commodityCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.commodityCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Style",
      selector: (row) => row?.style,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.style}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Content Group",
      selector: (row) => row?.fabricContentGroup,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricContentGroup}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Content",
      selector: (row) => row?.fabricContent,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricContent}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Old Article Number",
      selector: (row) => row?.oldArticleNumber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.oldArticleNumber}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "External Merchandise Category",
      selector: (row) => row?.externalMerchandiseCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.externalMerchandiseCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Brand",
      selector: (row) => row?.brand,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.brand}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fiber Code For Textiles Component 1",
      selector: (row) => row?.fiberCodeTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Percentage Share Of Fiber Component 1",
      selector: (row) => row?.percentageShareOfFiber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiber}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Fiber Code For Textiles Component 2",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Percentage Share Of Fiber Component 2",
      selector: (row) => row?.percentageShareOfFiber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiber}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Fiber Code For Textiles Component 3",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Percentage Share Of Fiber Component 3",
      selector: (row) => row?.percentageShareOfFiber,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.percentageShareOfFiber}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Fiber Code For Textiles Component 4",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Percentage Share Of Fiber Component 4",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Fiber Code For Textiles Component 5",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "280px",
    },
    {
      name: "Percentage Share Of Fiber Component 5",
      selector: (row) => row?.fiberCodeForTextiles,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fiberCodeForTextiles}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Country Of Origin Of Article Non Preferential",
      selector: (row) => row?.countryOfOriginOfArticle,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.countryOfOriginOfArticle}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "360px",
    },
    {
      name: "Future Planned Price1",
      selector: (row) => row?.futurePlannedPrice1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.futurePlannedPrice1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Date From Which Future Planned Price 1 Is Valid",
      selector: (row) => row?.futurePlannedPriceIsValid,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.futurePlannedPriceIsValid}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Control Code For Consumption Taxes In Foreign Trade",
      selector: (row) => row?.commodityCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.commodityCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Season Category",
      selector: (row) => row?.seasonCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Indicator Season Active In Inventory Management",
      selector: (row) => row?.seasonIndicator,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonIndicator}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Structure",
      selector: (row) => row?.segmentationStructure,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationStructure}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Strategy",
      selector: (row) => row?.segmentationStrategy,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationStrategy}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Segmentation Relevant",
      selector: (row) => row?.segmentationRelevant,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.segmentationRelevant}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Article Conversion Id For Characteristic Value Conversion",
      selector: (row) =>
        row?.articleConversionIdForCharacteristicValueConversion,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">
              {row?.articleConversionIdForCharacteristicValueConversion}
            </p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Grade",
      selector: (row) => row?.fashionGrade,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionGrade}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season Year",
      selector: (row) => row?.seasonYear,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonYear}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season",
      selector: (row) => row?.season,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.season}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Collection",
      selector: (row) => row?.fashionCollection,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionCollection}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fashion Theme",
      selector: (row) => row?.fashionTheme,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fashionTheme}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Season Indicator",
      selector: (row) => row?.seasonIndicator,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.seasonIndicator}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Storage Sect Id",
      selector: (row) => row?.storageSectID,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.storageSectID}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Stock Placement",
      selector: (row) => row?.stockPlacement,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.stockPlacement}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Stock Removal",
      selector: (row) => row?.stockRemoval,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.stockRemoval}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Gender",
      selector: (row) => row?.gender,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.gender}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Gender",
      selector: (row) => row?.subGender,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subGender}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Style Description",
      selector: (row) => row?.styleDescription,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.styleDescription}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Multiple Mrp",
      selector: (row) => row?.multipleMRP,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.multipleMRP}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Code",
      selector: (row) => row?.fabricCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Finish",
      selector: (row) => row?.fabricFinish,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricFinish}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fabric Type",
      selector: (row) => row?.fabricType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.fabricType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weave",
      selector: (row) => row?.weave,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.weave}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Yarn Type",
      selector: (row) => row?.yarnType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.yarnType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Leather",
      selector: (row) => row?.leather,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.leather}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fit",
      selector: (row) => row?.FIT,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.FIT}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Fit Name",
      selector: (row) => row?.FITName,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.FITName}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Design Code",
      selector: (row) => row?.designCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.designCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Design Type",
      selector: (row) => row?.designType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.designType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Collor Neck Pleate",
      selector: (row) => row?.collor_Neck_Pleate,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.collor_Neck_Pleate}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sleev",
      selector: (row) => row?.sleev,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.sleev}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Occasion",
      selector: (row) => row?.occasion,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.occasion}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Garment Finish",
      selector: (row) => row?.garmentFinish,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.garmentFinish}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Inseam",
      selector: (row) => row?.inseam,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.inseam}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Label",
      selector: (row) => row?.subLabel,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subLabel}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Category Group",
      selector: (row) => row?.categoryGroup,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.categoryGroup}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Sub Category",
      selector: (row) => row?.subCategory,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.subCategory}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Category Type",
      selector: (row) => row?.categoryType,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.categoryType}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Selable",
      selector: (row) => row?.selable,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.selable}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Returnable",
      selector: (row) => row?.returnable,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.returnable}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class1",
      selector: (row) => row?.class1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class2",
      selector: (row) => row?.class2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class3",
      selector: (row) => row?.class3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Class4",
      selector: (row) => row?.class4,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.class4}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode1",
      selector: (row) => row?.freeTextBarcode1,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode1}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode2",
      selector: (row) => row?.freeTextBarcode2,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode2}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Free Text Barcode3",
      selector: (row) => row?.freeTextBarcode3,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.freeTextBarcode3}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Wrap Count",
      selector: (row) => row?.WRAP_Count,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.WRAP_Count}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Weft Count",
      selector: (row) => row?.WEFT_Count,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.WEFT_Count}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Ends Per Inch",
      selector: (row) => row?.endsPerInch,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.endsPerInch}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Picks Per Inch",
      selector: (row) => row?.picksPerInch,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.picksPerInch}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Classification",
      selector: (row) => row?.TaxClassification,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row?.TaxClassification}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "140px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const handleCustomerRegister = () => {
    navigate(PLMConstants.PRODUCT_ARTICLES_ARTICLE_CREATION);
  };

  const showEditProduct = (productMatrix) => {
    setProductMatrixdat(productMatrix);
    setModalShowEditProduct(true);
    // setTimeout(() => setModalShowEditProduct(true), 0);
  };
  const hideAritcleEditModal = () => {
    setModalShowEditProduct(false);
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent ">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Article Master List</h2>
                <p className="subText">Articles Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Row className="filterBox p-2 m-2 mb-2">
              <Col xs={3} md={3} lg={3} className="commLeftRightPadding">
                <ComboboxField
                  label="Band"
                  placeholder=""
                  id="brand"
                  iconClassName="dropdownIcon"
                  name="brand"
                  code="brand"
                  description="bunk"
                  data={Brand}
                  getvalue={setDropdownData}
                // required={true}
                />
              </Col>

              <Col xs={3} md={3} lg={3} className="commLeftRightPadding">
                <ComboboxField
                  label="Category"
                  placeholder=""
                  id="category"
                  iconClassName="dropdownIcon"
                  name="category"
                  code="category"
                  description="category"
                  data={Category}
                  getvalue={setDropdownData}
                // required={true}

                />
              </Col>

              <Col xs={3} md={3} lg={3} className="commLeftRightPadding">
                <ComboboxField
                  label="Division"
                  placeholder=""
                  id="division"
                  iconClassName="dropdownIcon"
                  name="division"
                  code="division"
                  description="division"
                  data={Divison}
                  getvalue={setDropdownData}
                // required={true}
                />
              </Col>

              <Col xs={3} md={3} lg={3} className="commLeftRightPadding">
                <ComboboxField
                  label="Season"
                  placeholder=""
                  id="season"
                  iconClassName="dropdownIcon"
                  name="season"
                  code="season"
                  description="season"
                  data={Season}
                  getvalue={setDropdownData}
                // required={true}
                />
              </Col>
            </Row>
            <hr />
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle"> Article Master List</span>
                      <span className="subHeaderTitle">
                        View of Article and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => setShowUploadModal(true)}
                        >
                          Upload
                        </button>
                      </Col>
                      <Col xs={4} md={2} lg={2} className="me-2">
                        <button
                          className="btnTable"
                          onClick={handleCustomerRegister}
                        >
                          <i class="bi bi-person-plus"></i> Add Articles
                        </button>
                      </Col>

                      {config?.deactivateListBtn && (
                        <Col xs={4} md={2} lg={2} className="btnSpaceInMobile">
                          <button
                            className="btnTable"
                            onClick={() => setShowSupplierDeactivateModel(true)}
                          >
                            {/* <i className="bi bi-justify"></i> */}
                            Deactivate List
                          </button>
                        </Col>
                      )}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i class="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={articleData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={articleTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      <UploadArticleModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      // onSuccessUpload={handleUploadSuccess}
      />
      <ArticleEditModal
        show={modalShowEditProduct}
        onHide={() => hideAritcleEditModal()}
        data={productMatrixdat}
      />
    </main>
  );
};

export default ArticleList;
